import axios from "axios";
import { store } from "../../redux/store";
import { handleLogout } from "../../redux/authentication";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

// axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
// axios.defaults.headers["Content-Type"] = "application/json";
// axios.defaults.headers["api-key"] = process.env.REACT_APP_API_KEY;
// axios.defaults.headers["Accept"] = "application/json";

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT,
    headers: {
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_API_KEY,
        Accept: "application/json",
    },
});

// axios.interceptors.response.use(
//     function (response) {
//         if (response.data.statusCode == 401) {
//             store.dispatch(handleLogout());
//         }

//         return response;
//     },
//     function (error) {
//         return Promise.reject(error);
//     }
// );
instance.interceptors.request.use(
    function (config) {
        const access_token = store.getState().auth.userData.access_token;

        if (!!access_token) {
            config.headers.Authorization = `Bearer ${access_token}`;
        }

        // Do something before request is sent
        return config;
    },
    function (error) {
        if (
            error.response.data.statusCode === 404 ||
            error.response.data.statusCode === 401
        ) {
            store.dispatch(handleLogout());
        }
        return Promise.reject(error);
    }
);


// Add a response interceptor
instance.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response?.status === 401) {
            store.dispatch(handleLogout());
        }
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        return Promise.reject(error);
    }
);

export default instance;
